var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana2U(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 300,
    fill: "#cbc2bf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m147.42 272.9h60.218c23.985 0 31.13-1.531 39.295-28.068l20.413-0.51033-18.372 63.28h-145.44l-0.51033-17.351c109.21-106.66 111.25-122.48 112.27-138.3 2.5516-34.702-22.454-45.929-35.723-45.929-13.268 0-35.213 8.6755-56.646 52.564l-18.882-8.1652c28.578-80.121 76.549-76.549 91.859-76.039 37.764 1.0207 62.26 36.743 61.239 66.853-1.0206 40.826-18.882 46.95-109.72 131.66z",
    fill: "#130c0e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-390.58 9.6442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m902.67 78.173c54.312 54.307 87.906 129.31 87.906 212.16 0 165.7-134.32 300.02-300.01 300.02-82.836 0-157.83-33.576-212.12-87.877",
    fill: "#c1d7e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m850.91 492.4c-16.152 16.434-36.047 24.648-59.682 24.648-26.532 0-47.574-9.0841-63.144-27.24-14.712-17.304-22.056-39.348-22.056-66.169 0-28.824 12.54-61.687 37.626-98.605 20.46-30.282 44.538-56.803 72.222-79.585-4.0382 18.456-6.0602 31.572-6.0602 39.366 0 17.88 5.622 35.316 16.866 52.326 13.842 20.19 24.366 35.184 31.572 44.976 11.244 17.01 16.866 33.6 16.866 49.734 0 23.94-8.064 44.124-24.211 60.547zm-0.43177-92.329c-4.3261-9.6541-9.3718-16.08-15.138-19.248 0.86957 1.7281 1.2899 4.1881 1.2899 7.3561 0 6.0601-1.722 14.718-5.1782 25.944l-5.6281 17.31c0 10.08 5.0339 15.132 15.132 15.132 10.662 0 16.008-7.062 16.008-21.192 0-7.2061-2.1605-15.648-6.4862-25.302z",
    fill: "#061922"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana2U);
export default __webpack_public_path__ + "static/media/mana2u.61b1724d48bb753e2cc997c2059bb35c.svg";
export { ForwardRef as ReactComponent };